import React from 'react'
import { Field } from 'formik'

import { FieldPropsType } from '@interfaces/commons/FieldPropsType'
import { SortFieldAcceptProps, SortFieldProps } from './interface'

const withSortField = (Component: React.FC<SortFieldProps>) => {
  function Hoc({ name, onChange, ...props }: SortFieldAcceptProps) {
    return (
      <Field name={name}>
        {({ field, meta, form }: FieldPropsType<any>) => (
          <Component
            {...props}
            {...field}
            onChange={value => {
              form.setFieldValue(name, value)
              setTimeout(() => {
                form.setFieldTouched(name, true)
              })
              if (onChange) {
                onChange(value)
              }
            }}
          />
        )}
      </Field>
    )
  }

  return Hoc
}

export { withSortField }
